import { apiUrl2, xTravelWorldUrl } from '../../../settings'

export const updateXTravelMarginUrl = () => {
  return apiUrl2 + '/x-travel/updateAgentXTravelMargin'
}

export const singleAgentXTravelMarginUrl = () => {
  return apiUrl2 + '/x-travel/getAgentXTravelMargin'
}

export const singleXTravelExchangeMarginUrl = () => {
  return apiUrl2 + '/x-travel/getExchangeMargin'
}

export const updateXTravelExchangeMarginUrl = () => {
  return apiUrl2 + '/x-travel/updateExchangeMargin'
}

export const addXTravelFundTransferRequestUrl = () => {
  return apiUrl2 + '/xTravel/addXTravelFundTransferRequest'
}

export const getAllFundTransferRequestUrl = () => {
  return apiUrl2 + '/xTravel/getAllFundTransferRequest'
}

export const updateFundTransferRequestUrl = () => {
  return apiUrl2 + '/xTravel/updateFundTransferRequest'
}

export const getAgentMarginActivityUrl = () => {
  return apiUrl2 + 'x-travel/getAllAgentMarginActivity'
}

export const addDirectDepositUrl = () => {
  return xTravelWorldUrl + '/x-travel/addDirectDeposit'
}

export const getAllDirectDepositUrl = () => {
  return xTravelWorldUrl + '/x-travel/getAllDirectDeposit'
}
export const approveDirectDepositUrl = () => {
  return xTravelWorldUrl + '/x-travel/approveDirectDeposit'
}
export const getProfitAndLossUrl = () => {
  return xTravelWorldUrl + '/x-travel/getProfitLoss'
}

export const addEventXTravelUrl = () => {
  return xTravelWorldUrl + '/x-travel/addEventXTravel'
}
export const getAllEventsUrl = () => {
  return xTravelWorldUrl + '/x-travel/eventList'
}
export const getEventDataByIdUrl = () => {
  return xTravelWorldUrl + '/x-travel/getEventById'
}
export const addMeetingXTravelUrl = () => {
  return xTravelWorldUrl + '/x-travel/addMeeting'
}
export const getAllMeetingsUrl = () => {
  return xTravelWorldUrl + '/x-travel/meetingList'
}